import {FlowTypeEnumWithoutAuth} from 'presentation/utils';

type CheckBookingModal = CheckBookingModalEnum | `${CheckBookingModalEnum}`;

enum CheckBookingModalEnum {
	VERIFYING_DUPLICITY = 'verifyingDuplicity',
	VERIFYING_AUTH = 'verifyingAuth',
	VERIFYING_DISTRICTS = 'verifyingDistricts',
	VERIFYING_REQUEST_SCHEDULE = 'verifyingRequestSchedule',
	ERROR = 'error',
	DUPLICITY_STATE = 'duplicityState',
	NEED_AUTH = 'needAuth',
	SCRIPT_STATE = 'scriptState',
	NONE = 'none',
}

type UseBookingSpecialtyProps = {
	flowType: FlowTypeEnumWithoutAuth;
	handleNext: () => void;
};

export type {CheckBookingModal, UseBookingSpecialtyProps};

export {CheckBookingModalEnum};
